(function () {
  'use strict';
  if (window.DaLucaUniversalReviewRepairV398) return;
  window.DaLucaUniversalReviewRepairV398 = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }

  function reviewWidget() {
    return qs('.jdgm-rev-widg') || qs('#shopify-product-reviews') || qs('.jdgm-review-widget') || qs('.jdgm-widget');
  }

  function ensureVisible(el) {
    if (!el) return;
    var node = el;
    while (node && node !== document.body) {
      if (node.classList && (
        node.classList.contains('shopify-section') ||
        node.classList.contains('section-app-wrapper') ||
        node.classList.contains('app-wrapper') ||
        node.classList.contains('row') ||
        node.classList.contains('columns')
      )) {
        node.hidden = false;
        node.style.removeProperty('display');
        node.style.removeProperty('visibility');
        node.style.removeProperty('height');
        node.style.removeProperty('max-height');
        node.style.removeProperty('overflow');
      }
      node = node.parentElement;
    }
  }

  function normalizeTarget() {
    var widget = reviewWidget();
    if (!widget) return false;

    ensureVisible(widget);

    var section = widget.closest('.shopify-section, .section-app-wrapper') || widget.parentElement;
    if (section) {
      section.hidden = false;
      section.style.removeProperty('display');
      section.style.removeProperty('visibility');
      section.style.setProperty('margin-top', '0', 'important');
      section.style.setProperty('padding-top', '0', 'important');
    }

    var anchor = document.getElementById('daluca-reviews');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.id = 'daluca-reviews';
      anchor.className = 'daluca-product-details__review-anchor';
      anchor.setAttribute('aria-hidden', 'true');
    }

    /* Keep the hash target immediately above the real review content. */
    var targetHost = widget.parentElement || section;
    if (targetHost && anchor.parentElement !== targetHost) {
      targetHost.insertBefore(anchor, widget);
    } else if (targetHost && anchor.nextElementSibling !== widget) {
      targetHost.insertBefore(anchor, widget);
    }

    anchor.style.setProperty('display', 'block', 'important');
    anchor.style.setProperty('height', '1px', 'important');
    anchor.style.setProperty('margin', '0', 'important');
    anchor.style.setProperty('padding', '0', 'important');
    anchor.style.setProperty('scroll-margin-top', '110px', 'important');

    return true;
  }

  function scrollToReviews() {
    var tries = 0;
    function go() {
      tries += 1;
      if (normalizeTarget()) {
        var widget = reviewWidget();
        var anchor = document.getElementById('daluca-reviews');
        var target = anchor || widget;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (tries < 40) window.setTimeout(go, 100);
    }
    go();
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href="#daluca-reviews"], a[href="#shopify-product-reviews"]') : null;
    if (!link) return;
    event.preventDefault();
    scrollToReviews();
  }, true);

  function run() {
    normalizeTarget();
    if (location.hash === '#daluca-reviews' || location.hash === '#shopify-product-reviews') {
      window.setTimeout(scrollToReviews, 80);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  [150, 400, 900, 1600, 3000, 5000].forEach(function (ms) {
    window.setTimeout(normalizeTarget, ms);
  });

  if (document.body) {
    var timer = 0;
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.jdgm-rev-widg, .jdgm-widget, .jdgm-review-widget')) ||
            (node.querySelector && node.querySelector('.jdgm-rev-widg, .jdgm-widget, .jdgm-review-widget'))
          );
        });
      });
      if (!relevant) return;
      clearTimeout(timer);
      timer = window.setTimeout(normalizeTarget, 40);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

(function () {
  'use strict';
  if (!new URLSearchParams(window.location.search).has('judgeme_token')) return;
  if (window.DaLucaEmailReviewScrollV1) return;
  window.DaLucaEmailReviewScrollV1 = true;

  function start() {
    var started = Date.now();
    var stableSince = started;
    var previousTarget = null;
    var previousTop = null;
    var stopped = false;
    var timer = 0;
    var events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var listenerOptions = { capture: true, passive: true };

    function stop() {
      if (stopped) return;
      stopped = true;
      window.clearTimeout(timer);
      events.forEach(function (name) {
        document.removeEventListener(name, stop, listenerOptions);
      });
    }

    function visible(element) {
      if (!element || element.hidden) return false;
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 &&
        style.display !== 'none' && style.visibility !== 'hidden';
    }

    function align(targetTop) {
      var root = document.documentElement;
      var previousValue = root.style.getPropertyValue('scroll-behavior');
      var previousPriority = root.style.getPropertyPriority('scroll-behavior');
      var height = Math.max(root.scrollHeight, document.body.scrollHeight);
      var destination = Math.max(0, Math.min(targetTop - 110, height - window.innerHeight));
      if (Math.abs(destination - window.scrollY) < 8) return;
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      try {
        window.scrollTo(window.scrollX, destination);
      } finally {
        if (previousValue) root.style.setProperty('scroll-behavior', previousValue, previousPriority);
        else root.style.removeProperty('scroll-behavior');
      }
    }

    function tick() {
      if (stopped) return;
      var now = Date.now();
      if (now - started >= 12000) {
        stop();
        return;
      }
      var widget = document.querySelector('.jdgm-rev-widg') ||
        document.querySelector('#shopify-product-reviews') ||
        document.querySelector('.jdgm-review-widget');
      var target = null;
      if (visible(widget)) {
        var forms = widget.querySelectorAll('form');
        for (var i = 0; i < forms.length; i += 1) {
          if (visible(forms[i]) && forms[i].querySelector('textarea')) {
            target = forms[i];
            break;
          }
        }
        target = target || widget;
      }
      if (target) {
        var top = target.getBoundingClientRect().top + window.scrollY;
        if (target !== previousTarget || previousTop === null || Math.abs(top - previousTop) > 2) {
          stableSince = now;
        }
        previousTarget = target;
        previousTop = top;
        if (document.readyState === 'complete' && now - started >= 800 && now - stableSince >= 400) {
          align(top);
        }
      } else {
        previousTarget = null;
        previousTop = null;
        stableSince = now;
      }
      timer = window.setTimeout(tick, 200);
    }

    events.forEach(function (name) {
      document.addEventListener(name, stop, listenerOptions);
    });
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
